export const API2_DEFAULT = `${GO_BACKEND_URL}/api2`
export const API2_USERS = `${API2_DEFAULT}/users`
export const API2_PULSE = `${API2_DEFAULT}/pulse`
export const API2_SHCONTACTS = `${API2_DEFAULT}/sh-contacts`
export const API2_SHCOMPANIES = `${API2_DEFAULT}/sh-companies`
export const API2_COMPANIES = `${API2_DEFAULT}/companies`
export const API2_SHTOPICS = `${API2_DEFAULT}/sh-topics`
export const API2_TOPICS = `${API2_DEFAULT}/topics`
export const API2_CONTACTS = `${API2_DEFAULT}/contacts`
export const API2_CHATS = `${API2_DEFAULT}/chats`
export const API2_ENRICH = `${API2_DEFAULT}/enrich`
export const API2_ANALYTICS = `${API2_DEFAULT}/analytics`
export const API2_TENANTS = `${API2_DEFAULT}/tenants`
export const API2_INGEST = `${API2_DEFAULT}/ingest`
export const API2_INGEST_ACL = `${API2_DEFAULT}/ingest_acl`
export const API2_AUDIT_CLIENT = `${API2_DEFAULT}/audit/client`
export const API2_AUDIT_GROUPS = `${API2_DEFAULT}/audit/groups`
export const API2_AUDIT_USERS = `${API2_DEFAULT}/audit/users`
export const API2_AUDIT = `${API2_DEFAULT}/audit`
export const API2_FILES = `${API2_DEFAULT}/files`
export const API2_SHARED_FILES = `${API2_DEFAULT}/shared-files`
export const API2_SETTINGS = `${API2_DEFAULT}/settings`
export const API2_ALL_CAPS = `${API2_DEFAULT}/caps`
export const API2_FEEDBACK = `${API2_DEFAULT}/feedback`
export const API2_TASKS = `${API2_DEFAULT}/tasks`
export const API2_TOOLS = `${API2_DEFAULT}/tools`
